import { logo, logoIconBlack } from "@/constant/imagePath";
import { cn } from "@/helper/HelperFunction";
import { routes } from "@/routes";
import { cloneElement, useEffect, useRef, useState } from "react";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  setSideBarCollapsed,
  signOutRequest,
} from "../../../store/auth/authSlice";
import classes from "./SideBar.module.css";

const SideBar = ({
  isMobile,
  showLogo = true,
  floating,
  layout = "vertical",
}) => {
  const { user, isSidebarCollapsed } = useSelector(
    (state) => state.authReducer
  );
  const [popper, setPopper] = useState(null);
  const popperRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleSubmitSignOut = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };

  return (
    <div
      className={cn(
        classes.mainContainer,
        floating && classes.floating,
        isMobile && classes.isMobileContainer,
        layout === "horizontal" && classes.horizontalMainContainer
      )}
    >
      {showLogo && (
        <Link to="/" className={classes.logoContainer}>
          {isSidebarCollapsed ? (
            <img
              src={logoIconBlack}
              alt="HaggleIt"
              className={classes.collapsedLogo}
            />
          ) : (
            <img src={logo} alt="HaggleIt" />
          )}
        </Link>
      )}
      {!isMobile && (
        <div
          className={classes.toggler}
          onClick={() => {
            dispatch(setSideBarCollapsed(!isSidebarCollapsed));
          }}
        >
          <TbLayoutSidebarLeftCollapse
            className={isSidebarCollapsed ? classes.toggleIcon : ""}
            size={25}
          />
        </div>
      )}
      <div
        className={cn(
          classes.itemsScrollContainer,
          layout === "horizontal" && classes.horizontalItemsScrollContainer,
          isSidebarCollapsed && classes.collapsedItemsScrollContainer
        )}
      >
        <div
          className={cn(
            classes.itemsList,
            layout === "horizontal" && classes.horizontalItemsList
          )}
        >
          {routes
            ?.filter((e) => e.showInSidebar)
            .map((item, index) => {
              return (
                <RenderItem
                  key={index}
                  item={item}
                  isCollapsed={isSidebarCollapsed}
                  setPopper={setPopper}
                  popperRef={popperRef}
                  layout={layout}
                  isMobile={isMobile}
                />
              );
            })}
        </div>

        {/* <hr className={classes.hr} />
        <div
          className={cn(
            classes.logoutContainer,
            classes.logoutContainerCollapsed
          )}
          onClick={HandleSubmitSignOut}
        >
          <p className={classes.logoutItem}>
            {!isSidebarCollapsed && <p>LOGOUT</p>}
            <span>
              <BiLogOut size={20} />
            </span>
          </p>
        </div> */}
      </div>

      {/* <hr className={classes.hr} /> */}
      <div
        className={cn(
          classes.logoutContainer,
          isSidebarCollapsed && classes.logoutContainerCollapsed
          // classes.logoutContainerCollapsed
        )}
        onClick={HandleSubmitSignOut}
      >
        <p
          className={`${classes.logoutItem} ${
            !isSidebarCollapsed && classes.logoutItemCollapsed
          } ${classes.activeLogoutItem}`}
        >
          <span>
            <RiLogoutCircleRLine size={20} />
          </span>
          {!isSidebarCollapsed && <p>LOGOUT</p>}
        </p>
      </div>
      {popper && isSidebarCollapsed && (
        <span className={classes.popper} style={{ top: `${popper.pos}px` }}>
          {popper.value}
        </span>
      )}
    </div>
  );
};

export default SideBar;

const RenderItem = ({
  item,
  isCollapsed,
  setPopper,
  popperRef,
  layout,
  isMobile,
}) => {
  const { path, title, icon, subMenu = [] } = item;
  const location = useLocation();
  const pathname = location?.pathname;

  const isActive =
    path === "#"
      ? false
      : pathname === path || (path !== "/" && pathname.startsWith(path + "/"));
  const isSubMenuActive = subMenu.some(
    (subItem) =>
      pathname === subItem.path ||
      (subItem.path !== "/" && pathname.startsWith(subItem.path + "/"))
  );

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(isSubMenuActive);

  useEffect(() => {
    if (isSubMenuActive) {
      setIsSubMenuOpen(true);
    }
  }, [pathname, isSubMenuActive]);

  const handleMouseEnter = (e, itemTitle) => {
    if (isCollapsed) {
      if (popperRef.current) {
        clearTimeout(popperRef.current);
      }
      const parentScrollTop =
        e.currentTarget.closest("." + classes.itemsScrollContainer)
          ?.scrollTop || 0;
      setPopper({
        pos: e.currentTarget.offsetTop - parentScrollTop + 10,
        value: itemTitle,
      });
    }
  };

  const handleMouseLeave = () => {
    if (isCollapsed) {
      popperRef.current = setTimeout(() => {
        setPopper(null);
      }, 100);
    }
  };

  const toggleSubMenu = (e) => {
    if (subMenu.length > 0) {
      e.preventDefault();
      setIsSubMenuOpen(!isSubMenuOpen);
    }
  };

  const effectivePath = subMenu.length > 0 ? "#" : path;
  const itemIsActive = subMenu.length > 0 ? isSubMenuActive : isActive;

  return (
    <>
      <Link
        to={effectivePath}
        className={cn(
          classes.listItemContainer,
          itemIsActive && classes.active,
          isCollapsed && classes.isCollapsed,
          layout === "horizontal" && classes.horizontalItemsList,
          // isMobile && classes.mobileItemsList
          isMobile && classes.isMobile
        )}
        onClick={toggleSubMenu}
        onMouseEnter={(e) => handleMouseEnter(e, title)}
        onMouseLeave={handleMouseLeave}
        aria-expanded={subMenu.length > 0 ? isSubMenuOpen : undefined}
      >
        {icon && cloneElement(icon, { className: classes.icon })}
        {/* {!isCollapsed && <span>{title}</span>} */}
        {(!isCollapsed || isMobile) && <span>{title}</span>}
        {subMenu.length > 0 &&
          !isCollapsed &&
          (isSubMenuOpen ? (
            <TiArrowSortedDown size={20} className={classes.dropDownIcon} />
          ) : (
            <TiArrowSortedUp size={20} className={classes.dropDownIcon} />
          ))}
      </Link>

      {isSubMenuOpen && subMenu.length > 0 && (
        <div
          className={cn(classes.subMenu, isCollapsed && classes.isCollapsed)}
        >
          {subMenu
            .filter((subItem) => subItem.showInSidebar)
            .map((subItem, index) => {
              const isSubItemActive =
                pathname === subItem.path ||
                (subItem.path !== "/" &&
                  pathname.startsWith(subItem.path + "/"));
              return (
                <Link
                  key={index}
                  to={subItem.path}
                  className={cn(
                    classes.innerItemContainer,
                    isSubItemActive && classes.active,
                    isCollapsed && classes.isCollapsed
                  )}
                  onMouseEnter={(e) => handleMouseEnter(e, subItem.title)}
                  onMouseLeave={handleMouseLeave}
                >
                  {subItem.icon &&
                    cloneElement(subItem.icon, {
                      className: classes.innerIcon,
                    })}
                  {!isCollapsed && <span>{subItem.title}</span>}
                </Link>
              );
            })}
        </div>
      )}
    </>
  );
};
